import script from "./FormElementSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./FormElementSelect.vue?vue&type=script&setup=true&lang=js"

import "./FormElementSelect.vue?vue&type=style&index=0&id=b56d966c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b56d966c"]])

export default __exports__